import { render, staticRenderFns } from "./Fa7Pro.vue?vue&type=template&id=4aa83705"
import script from "./Fa7Pro.vue?vue&type=script&lang=js"
export * from "./Fa7Pro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports